import { render, staticRenderFns } from "./BulkAction.vue?vue&type=template&id=0ae9f1e3&scoped=true"
import script from "./BulkAction.vue?vue&type=script&lang=js"
export * from "./BulkAction.vue?vue&type=script&lang=js"
import style0 from "./BulkAction.vue?vue&type=style&index=0&id=0ae9f1e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae9f1e3",
  null
  
)

export default component.exports